"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.GroupModeration = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _GroupV = require("./GroupV2");

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _ArrowBack = _interopRequireDefault(require("@insided/destination/icons/ArrowBack"));

var _AddCircle = _interopRequireDefault(require("@insided/destination/icons/AddCircle"));

var _SupervisedUserCircle = _interopRequireDefault(require("@insided/destination/icons/SupervisedUserCircle"));

var _classnames = _interopRequireDefault(require("classnames"));

var _moderation = require("./moderation");

var _service = require("./service");

var _qs = _interopRequireDefault(require("qs"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var DEFAULT_CURRENT_PAGE = 1;
var DEFAULT_PAGE_SIZE = 1;
var views = {
  members: 'Members',
  applicants: 'Applicants',
  reportedContent: 'Reported content'
};

var getViewFromUrl = function getViewFromUrl() {
  var _ref;

  var searchQuery = typeof window !== 'undefined' ? window.location.search : '';

  var queryParameters = _qs.default.parse(searchQuery, {
    ignoreQueryPrefix: true
  });

  return (_ref = queryParameters.view) !== null && _ref !== void 0 ? _ref : null;
};

var setView = function setView(view) {
  window.history.pushState('', '', "?".concat(_qs.default.stringify({
    view: view
  })));
};

var GroupModeration = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(GroupModeration, _Component);

  var _super = _createSuper(GroupModeration);

  function GroupModeration(props) {
    var _this;

    (0, _classCallCheck2.default)(this, GroupModeration);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "componentDidMount", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.fetchApplicantsCount();

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "fetchApplicantsCount", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
      var _yield$fetchMembers, total;

      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return (0, _service.fetchMembers)({
                groupId: _this.props.group.id,
                page: DEFAULT_CURRENT_PAGE,
                pageSize: DEFAULT_PAGE_SIZE,
                filter: _service.fetchMembersFilters.Applicants
              });

            case 3:
              _yield$fetchMembers = _context2.sent;
              total = _yield$fetchMembers.total;

              _this.setState({
                applicantsTotalCount: total
              });

              _context2.next = 10;
              break;

            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](0);

            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 8]]);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onBackToGroupClick", function () {
      var _this$props$group;

      window.location.href = (0, _absoluteUrlRuntime.resolveUrl)("/groups/".concat((_this$props$group = _this.props.group) === null || _this$props$group === void 0 ? void 0 : _this$props$group.id));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onSwitchView", function (view) {
      setView(view);

      _this.setState({
        view: views[view]
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onApplicantsUpdate", function (count) {
      _this.setState({
        applicantsTotalCount: count
      });
    });
    var viewFromUrl = getViewFromUrl(); // eslint-disable-next-line react/state-in-constructor

    _this.state = {
      view: views[viewFromUrl],
      applicantsTotalCount: null
    };
    return _this;
  }

  (0, _createClass2.default)(GroupModeration, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          canSee = _this$props.canSee,
          group = _this$props.group,
          communityLocale = _this$props.communityLocale;
      var _this$state = this.state,
          view = _this$state.view,
          applicantsTotalCount = _this$state.applicantsTotalCount;
      return (0, _preact.h)("div", {
        className: "group-moderation-wrapper"
      }, canSee ? (0, _preact.h)("div", {
        className: "sitewidth group-moderation"
      }, (0, _preact.h)("div", {
        className: "group-moderation__sidebar"
      }, (0, _preact.h)("button", {
        className: "group-moderation__sidebar__back",
        onClick: this.onBackToGroupClick
      }, (0, _preact.h)(_ArrowBack.default, {
        height: 20,
        width: 20
      }), (0, _preact.h)(_phrase.default, {
        p: "groups.back.to.group"
      })), (0, _preact.h)("div", {
        className: "group-moderation__sidebar__menu"
      }, group.visibility !== _GroupV.GroupVisibility.Public ? (0, _preact.h)("button", {
        className: (0, _classnames.default)('group-moderation__sidebar__menu__item', {
          active: view === views.applicants
        }),
        onClick: function onClick() {
          _this2.onSwitchView('applicants');
        }
      }, (0, _preact.h)("div", {
        className: "group-moderation__sidebar__menu__item__title"
      }, (0, _preact.h)(_AddCircle.default, {
        height: 20,
        width: 20
      }), (0, _preact.h)(_phrase.default, {
        p: "groups.moderation.join.requests"
      })), (0, _preact.h)("div", {
        className: (0, _classnames.default)('group-moderation__sidebar__menu__item__counter', {
          active: !!applicantsTotalCount
        })
      }, applicantsTotalCount)) : null, (0, _preact.h)("button", {
        className: (0, _classnames.default)('group-moderation__sidebar__menu__item', {
          active: view === views.members
        }),
        onClick: function onClick() {
          _this2.onSwitchView('members');
        }
      }, (0, _preact.h)("div", {
        className: "group-moderation__sidebar__menu__item__title"
      }, (0, _preact.h)(_SupervisedUserCircle.default, {
        height: 20,
        width: 20
      }), (0, _preact.h)(_phrase.default, {
        p: "groups.group.members"
      }))))), (0, _preact.h)("div", {
        className: "group-moderation__main"
      }, view === views.members ? (0, _preact.h)(_moderation.Members, {
        group: group,
        communityLocale: communityLocale
      }) : null, view === views.applicants ? (0, _preact.h)(_moderation.Applicants, {
        group: group,
        onApplicantsUpdate: this.onApplicantsUpdate
      }) : null)) : null);
    }
  }]);
  return GroupModeration;
}(_preact.Component);

exports.GroupModeration = GroupModeration;
var _default = GroupModeration;
exports.default = _default;